import { UserProfile, UserWorkoutSession } from 'fitbeat.gym-core';
import React from 'react';
import { translate } from 'react-i18next';
import { ActivityIndicator, StyleSheet, View, Platform } from 'react-native';
import { BookOrJoinWorkoutButton } from '../../Bookings/components/BookOrJoinWorkoutButton';
import { bookings } from '../../Bookings/reducers';
import Theme from '../../theme';
import { Tile } from '../../ui/components';
import { defaultScale } from '../../utils';
import WeeklyGoal from './WeeklyGoal';

export interface IBookingDashProps {
  isWorkoutLoading: boolean;
  t: (key: string) => string;
  navigation: any;
  userProfile: UserProfile;
  workoutSessionService: any;
  bookings: UserWorkoutSession[];
  bookingDashTileSelected: () => void;
  toggleWeightTargetModal: (visible: boolean) => void;
  toggleRecalculateMilestone: (visible: boolean) => void;
}

export class BookingDashTile extends React.Component<IBookingDashProps, any> {
  public bookingDashTileHandler = () => {
    this.props.navigation.navigate('UserDashboard');
    this.props.bookingDashTileSelected();
  }

  public render() {
  const {
    isWorkoutLoading,
    userProfile,
    toggleWeightTargetModal,
    workoutSessionService,
    t,
    navigation,
  } = this.props;

  return (
      <Tile customStyle={styles.tileContainer} onPress={this.bookingDashTileHandler}>
        {isWorkoutLoading ?
          <View style={styles.loaderContainer}>
            <ActivityIndicator
              size='large'
              animating={isWorkoutLoading}
              color={Theme.PRIMARY}
            />
          </View>
          :
          <>
            <WeeklyGoal
              userProfile={userProfile}
              t={this.props.t}
              toggleWeightTargetModal={toggleWeightTargetModal}
              navigateToBodyMetricsTab={() => {
                this.props.navigation.navigate('BodyMetricsTab');
              }}
              navigateToWorkoutsTab={() => {
                if (Platform.OS === 'web') {
                  this.props.navigation.navigate('StatsScreen');
                } else {
                  this.props.navigation.navigate('WorkoutPerformanceTab');
                }
              }}
              navigateToChallengesTab={() => {
                this.props.navigation.navigate('ChallengesTab');
              }}
              />
          </>
        }
      </Tile>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  tileContainer: {
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    zIndex: 1,
    paddingHorizontal: 12,
    marginTop: defaultScale(22),
    backgroundColor: Theme.GREY_LIGHT,
  },
  loaderContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  actionButtonContainer: {
    padding: defaultScale(12),
  },
});

export default translate(['dashboard', 'bookings'], { wait: true })(BookingDashTile);
